export const ROUTES = {
  // Root
  home: "/home",
  update: "/update",

  // Authentication
  login: "/login",
  welcome: "/welcome",

  // Unico
  biometryValidation: "/biometryValidation",

  // Proposals proposals: "/proposals",
  proposals: "/proposals",
  proposalsViewInfo: "/proposals/view",
  proposalsFilter: "/proposals/filter",
  proposalsDone: "/proposals/done",
  proposalsInvalidToken: "/proposals/invalid-token",
  proposalsValidToken: "/proposals/valid-token",

  // Pré-Proposals
  preProposalsInfoSecurity: "/preProposals/infoSecurity",
  preProposalsPhoneNumber: "/preProposals/phoneNumber",
  preProposalsConfirmToken: "/preProposals/confirmToken",
  preProposalsBiometryValidation: "/preProposals/biometryValidation",
  preProposalsSelectProduct: "/preProposals/selectProduct",
  preProposalsSelectDocumentType: "/preProposals/selectDocumentType",
  preProposalsSelectFinancialService: "/preProposals/selectFinancialService",
  preProposalsSelectServicePoint: "/preProposals/selectServicePoint",
  preProposalsSelectAttendant: "/preProposals/selectAttendant",
  preProposalsVerifyInformations: "/preProposals/verifyInformations",
  preProposalsSelectDocuments: "/preProposals/selectDocumens",
  preProposalsCaptureDocument: "/preProposals/captureDocument",

  // Transactions
  transactions: "/transactions",
  cancelTransactionOptions: "/transactions/cancel-options",
  cancelTransaction: "/transactions/cancel",

  // Profile
  profile: "/profile",
  editProfile: "/profile/edit",
  changePassword: "/profile/change-password",

  // Support
  support: "/support",

  // Sales
  sales: "/sales",
  salesFirstAccess: "/sales/first-access",
  salesFirstAccessSuccess: "/sales/first-access/success",

  // Receipts
  selectSecondCopyOfReceipt: "/receipts/select-second-copy",
  secondCopyOfReceipt: "/receipts/second-copy",
  closingOfTheDay: "/receipts/closing-of-the-day",

  // Withdraw
  emergencyWithdrawOptions: "/emergency-withdraw/options",
  emergencyWithdraw: "/emergency-withdraw/withdraw",
  emergencyWithdrawConfirm: "/emergency-withdraw/confirm",
  emergencyWithdrawReceipt: "/emergency-withdraw/receipt",

  // Consult Limits
  consultLimitsVerifyIdentity: "/consult-limits/verify-identity",
  consultLimitsReceipt: "/consult-limits/receipt",

  // Invoice Payments
  invoicePaymentOptions: "/invoice-payment/options",
  invoicePayment: "/invoice-payment/invoice",
  dealPayment: "/invoice-payment/deal",
  invoicePaymentConfirm: "/invoice-payment/confirm",
  invoicePaymentReceipt: "/invoice-payment/receipt",

  // Simulate Installments
  simulateInstallmentsOptions: "/simulate-installments/options",
  simulateInstallmentsValue: "/simulate-installments/value",
  simulateInstallments: "/simulate-installments/simulate",
  simulateInstallmentsReceipt: "/simulate-installments/receipt",

  // Select Store
  selectStore: "/select-store",

  // Credit Proposal Form
  creditProposalPersonalData: "/credit-proposal/personal-data",
  creditProposalAddress: "/credit-proposal/address",
  creditProposalProfessionData: "/credit-proposal/profession-data",
  creditProposalInvoiceData: "/credit-proposal/invoice-data",
  creditProposalPersonalReference: "/credit-proposal/personal-reference",
  creditProposalReview: "/credit-proposal/review",
  creditProposalDetails: "/credit-proposal/details/:id",
  creditProposalSelectFinancialService: "/credit-proposal/financial-services",
  creditProposalSelectProduct: "/credit-proposal/select-product",
  creditProposalSelectServicePoint: "/credit-proposal/service-point",

  // Fidelity Proposal Form
  fidelityProposalCompleteRegistration:
    "/fidelity-proposal/complete-registration",
  fidelityProposalReview: "/fidelity-proposal/review",

  // New Transaction Form / Flow
  newTransactionCaptureOptions: "/new-transaction/capture-options",
  newTransactionIdentity: "/new-transaction/identity",
  newTransactionValue: "/new-transaction/value",
  newTransactionFidelityOptions: "/new-transaction/fidelity-options",
  newTransactionPaymentOptions: "/new-transaction/payment-options",
  newTransactionInstallments: "/new-transaction/installments",
  newTransactionReview: "/new-transaction/review",
  newTransactionConfirm: "/new-transaction/confirm",
  newTransactionReceipt: "/new-transaction/receipt",
  newTransactionQRCode: "/new-transaction/qr-code",

  // Draft
  draftHome: "/drafts",

  // Credit Table
  creditTableHome: "/credit-table",
  sendCreditTable: "/send-credit-table",

  // Proposal Implementation
  proposalImplementationInvoiceDate: "/proposal-implementation/invoice-date",
  proposalImplementationPersonalReference:
    "/proposal-implementation/personal-reference",
  proposalEffectiveSuccess: "/proposal-effective-success",

  // Reports
  reports: "/reports",
  reportAnalysedProposals: "/reports/reportAnalysedProposals",
  reportApprovalTypes: "/reports/reportApprovalTypes",
  reportAttendants: "/reports/reportAttendants",
  reportGeneralProposals: "/reports/reportGeneralProposals",
  reportMonthlySales: "/reports/reportMonthlySales",
  reportSalesByStore: "/reports/reportSalesByStore",
  reportOverdueWallet: "/reports/reportOverdueWallet",
  reportReasonDenial: "/reports/reportReasonDenial",
  reportSelectFilters: "/reports/reportSelectFilters"
};
